export default "__VITE_ASSET__302eNWJb__"